goog.provide("shadow.js.shim.module$react_reflex");
goog.provide("module$shadow_js_shim_module$react_reflex");
shadow.js.shim.module$react_reflex = shadow.js.nativeProvides["react-reflex"] = shadow$bridge("react-reflex");
module$shadow_js_shim_module$react_reflex.default = shadow.js.shim.module$react_reflex;
